import React from "react";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import ToolTip from "app/routes/Scheduling/ToolTip";

interface RemainingSessionsProps {
  unlimited: boolean;
  remaining: number;
  updateRemainingSessions: (purchaseId, incrementValue: number, rateLinkId?: number) => void;
  purchaseId: string;
  rateLinkId?: number;
}

export default function RemainingSessions({
  remaining,
  unlimited,
  updateRemainingSessions,
  purchaseId,
  rateLinkId
}: RemainingSessionsProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.remainingSessions}>
      <div className={styles.textContainer}>
        <p className={styles.sectionTitleSessions}>{t("Remaining Sessions")}</p>
        <ToolTip
          text={t(
            "Here you can set the amount of remaining sessions for this athlete."
          )}
          selected={true}
          fontSize={"16px"}
          orientation={"right"}
          iconColor={"gray"}
        />
      </div>
      <div className={styles.remainingInputWrapper}>
        <button
          className={styles.decrementButton}
          onClick={() => {
            if (remaining > 0) {
              updateRemainingSessions(purchaseId, -1, rateLinkId);
            }
          }}
          disabled={remaining === 0 || unlimited === true}
        >
          <i className="fas fa-minus"></i>
        </button>

        {unlimited === true ? (
          <div className={styles.infiniteSessions}>
            <span className={styles.infinitySymbol}>&infin;</span>
          </div>
        ) : (
          <input
          type="number"
          value={remaining}
          className={styles.remainingInput}
          readOnly/>
        )}

        <button
          className={styles.incrementButton}
          onClick={() => updateRemainingSessions(purchaseId, 1, rateLinkId)}
          disabled={unlimited === true}
        >
          <i className="fas fa-plus"></i>
        </button>
      </div>
    </div>
  );
}
